import { render } from "./VenueGroupSidebar.vue?vue&type=template&id=e0d3ae1a&scoped=true"
import script from "./VenueGroupSidebar.vue?vue&type=script&lang=js"
export * from "./VenueGroupSidebar.vue?vue&type=script&lang=js"

import "./VenueGroupSidebar.vue?vue&type=style&index=0&id=e0d3ae1a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0d3ae1a"]])

export default __exports__